<template>
<div class="page-content">
  <nav class="page-breadcrumb" id="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ breadcrumbA }}</li>
      <li class="breadcrumb-item active" aria-current="page">
        {{ breadcrumbB }}
      </li>
    </ol>
  </nav>

  <div class="row">
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title">Ajustes aprobados: resolución o rechazo V1.1</h6>
          <p class="card-description">
            <span style="margin-left:5px;margin-top:5px;" class="badge badge-warning">En espera</span>
            <span style="margin-left:5px;margin-top:5px;" class="badge badge-success">Resuelto</span>
            <span style="margin-left:5px;margin-top:5px;" class="badge badge-danger">Rechazado</span>
            <span style="margin-left:5px;margin-top:5px;" class="badge badge-info">Auditado</span>
          </p>

          <div class="habilitar-ajuste-box">
            <div>
              <strong>Estado de carga de ajustes:</strong>
              <span class="badge text-uppercase ml-2" :class="habilitarAjuste ? 'badge-success' : 'badge-danger'">
                {{ habilitarAjuste ? 'Habilitado' : 'Deshabilitado' }}
              </span>
              <small class="text-muted d-block mt-1">
                Firebase: <code>habilitarajuste</code> = {{ habilitarAjuste ? 'true' : 'false' }}
              </small>
            </div>

            <button
              class="btn btn-sm"
              :class="habilitarAjuste ? 'btn-danger' : 'btn-success'"
              :disabled="habilitarAjusteLoading"
              @click="toggleHabilitarAjuste"
            >
              <span v-if="habilitarAjusteLoading">Actualizando...</span>
              <span v-else>{{ habilitarAjuste ? 'Deshabilitar' : 'Habilitar' }}</span>
            </button>
          </div>

          <hr />
        </div>
      </div>
    </div>
  </div>

  <lista-carga v-if="load"></lista-carga>

  <div class="row" v-else>
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-4 col-sm-12">
              <label class="mr-sm-2">Mes y año</label>
              <input type="month" class="form-control mb-2 mr-sm-2" id="mes_anio" v-model="mesAnioFiltro" />
            </div>
            <div class="col-md-4 col-sm-12">
              <label class="mr-sm-2 w-100">&nbsp;</label>
              <button class="btn btn-md btn-success w-100" id="buscar" ref="btnBuscarAjustes" type="button" :disabled="buscandoAjustes" @click.stop.prevent="buscarAjustesMes">{{ buscandoAjustes ? 'Consultando...' : 'Consultar Ajustes' }}</button>
            </div>
            <div class="col-md-4 col-sm-12">
              <label class="mr-sm-2 w-100">&nbsp;</label>
              <button class="btn btn-md btn-secondary w-100" id="limpiar_filtro_mes" ref="btnVerTodosAjustes" type="button" @click.stop.prevent="verTodosAjustes">Ver todos</button>
            </div>
          </div>

          <div v-if="mensajeFiltro" class="alert mb-3" :class="mensajeFiltroTipo">
            {{ mensajeFiltro }}
          </div>

          <div class="table-responsive">
            <table
              id="ajustes_resolucion"
              class="table table-theme table-row v-middle"
              data-plugin="dataTable"
            >
              <colgroup>
                <col style="width: 95px" />
                <col style="width: 190px" />
                <col style="width: 95px" />
                <col style="width: 145px" />
                <col style="width: 150px" />
                <col style="width: 150px" />
                <col style="width: 115px" />
                <col style="width: 150px" />
                <col style="width: 85px" />
                <col style="width: 190px" />
                <col style="width: 150px" />
                <col style="width: 90px" />
                <col style="width: 170px" />
                <col style="width: 145px" />
                <col style="width: 190px" />
                <col style="width: 145px" />
              </colgroup>

              <thead>
                <tr>
                  <th><span class="text-muted">Estado</span></th>
                  <th><span class="text-muted">Motivo</span></th>
                  <th><span class="text-muted">ID ajuste</span></th>
                  <th><span class="text-muted">Fecha carga</span></th>
                  <th><span class="text-muted">Regional</span></th>
                  <th><span class="text-muted">Zonal</span></th>
                  <th><span class="text-muted">DNI Regional</span></th>
                  <th><span class="text-muted">Operación</span></th>
                  <th><span class="text-muted">Legajo</span></th>
                  <th><span class="text-muted">Empleado</span></th>
                  <th><span class="text-muted">Concepto</span></th>
                  <th><span class="text-muted">Cantidad</span></th>
                  <th><span class="text-muted">Detalle</span></th>
                  <th><span class="text-muted">Gestionado por</span></th>
                  <th><span class="text-muted">Motivo</span></th>
                  <th><span class="text-muted">Acción</span></th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="caso in ajustes" :key="caso.fireId">
                  <!-- 1 Estado resolución -->
                  <td class="text-sm text-wrap">
                    <span class="badge text-uppercase" :class="badgeResolucion(caso.status_resolucion)">
                      {{ caso.status_resolucion }}
                    </span>
                  </td>

                  <!-- 2 Motivo seleccionado (solo texto) -->
                  <td class="text-sm text-wrap">
                    {{ caso.motivo_auditado || caso.motivo || '-' }}
                  </td>

                  <!-- 3 ID ajuste -->
                  <td class="text-sm text-wrap">{{ caso.fireIdCorto }}</td>

                  <!-- 3 Fecha carga -->
                  <td class="text-sm text-wrap">{{ caso.fecha_carga }}</td>

                  <!-- 4 Regional -->
                  <td class="text-sm text-wrap">{{ caso.responsable }}</td>

                  <!-- 5 Zonal -->
                  <td class="text-sm text-wrap">{{ caso.zonal }}</td>

                  <!-- 6 DNI Regional -->
                  <td class="text-sm text-wrap">{{ caso.responsable_dni }}</td>

                  <!-- 7 Operación -->
                  <td class="text-sm text-wrap">{{ caso.operacion_raiz }}</td>

                  <!-- 7 Legajo -->
                  <td class="text-sm text-wrap">{{ caso.legajo }}</td>

                  <!-- 8 Empleado -->
                  <td class="text-sm text-wrap">{{ caso.nombre }}</td>

                  <!-- 9 Concepto -->
                  <td class="text-sm text-wrap">{{ caso.novedad }}</td>

                  <!-- 10 Cantidad -->
                  <td class="text-sm text-wrap">{{ caso.cantidad }}</td>

                  <!-- 11 Detalle -->
                  <td class="text-sm text-wrap">
                    
                    <button class="btn btn-sm btn-info mt-1" @click="verDetalle(caso)">Ver detalle</button>
                  </td>

                  <!-- 12 Gestionado por -->
                  <td class="text-sm text-wrap">
                    <span v-if="caso.gestor_cierre_nombre && caso.gestor_cierre_nombre !== '-'">
                      {{ caso.gestor_cierre_nombre }}<br />
                      <small>{{ caso.fecha_cierre }}</small>
                    </span>
                    <span v-else>-</span>
                  </td>

                  <!-- 14 Motivo (select de carga) -->
                  <td class="text-sm text-wrap">
                    <select
                      class="custom-select motivoSelect"
                      :value="caso.motivo_auditado || caso.motivo || ''"
                      :disabled="esCasoCerrado(caso.status_resolucion)"
                      @change="cambiarMotivo($event, caso)"
                    >
                      <option value="">Seleccione motivo</option>
                      <option v-for="motivo in motivosAjuste" :key="motivo" :value="motivo">
                        {{ motivo }}
                      </option>
                    </select>
                  </td>

                  <!-- 15 Acción -->
                  <td class="text-sm text-wrap">
                    <select
                      class="custom-select mr-3 resolucionSelect"
                      :value="caso.status_resolucion"
                      :disabled="esCasoCerrado(caso.status_resolucion)"
                      @change="cambiarResolucion($event, caso)"
                    >
                      <option value="En espera">En espera</option>
                      <option value="Resuelto">Resuelto</option>
                      <option value="Rechazado">Rechazado</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import $ from "jquery";
import Swal from "sweetalert2";
require("datatables.net");
require("datatables.net-buttons/js/buttons.colVis.js")();
require("datatables.net-buttons/js/buttons.html5.js")();
require("datatables.net-buttons/js/buttons.flash.js")();
require("datatables.net-buttons/js/buttons.print.js")();
require("../../../public/assets/css/data-table-estilos-propios.css");

import firebase from "firebase/app";
import "firebase/database";

import ListaCarga from "../ListaCarga";
import moment from "moment";

const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
const userPermission = JSON.parse(sessionStorage.getItem("userPermisos") || "[]");
const DIAGRAMA_FULL_URL = "https://auth.foodservice.com.ar/index_dev.php?type=diagramafull&access_token=1234567";
const MOTIVOS_AJUSTE = [
  "ERROR/OMISION CARGA ZONAL",
  "ERROR RRLL",
  "ERROR SISTEMA",
  "ERROR ESTUDIO LIQUIDACION",
  "ERROR CH",
  "OTRO"
];

export default {
  name: "AjustesResolucionSector",
  components: { ListaCarga },
  data: () => ({
    breadcrumbA: "Inicio",
    breadcrumbB: "Resolución de Ajustes Aprobados",
    descripcion: "Listado de ajustes aprobados por Génesis para resolver, rechazar y cerrar",
    ajustes: [],
    load: true,
    moduloPermiso: "AjustesResolucion",
    habilitarAjuste: false,
    habilitarAjusteLoading: false,
    motivosAjuste: MOTIVOS_AJUSTE,
    habilitarAjusteRef: null,
    mesAnioFiltro: "",
    filtroDesde: "",
    filtroHasta: "",
    mensajeFiltro: "",
    mensajeFiltroTipo: "alert-info",
    buscandoAjustes: false,
    diagramaFull: [],
    diagramaCargado: false,
    diagramaCargando: false,
    diagramaPromise: null,
    diagramaPorOperacion: {},
    diagramaPorOperacionLegajo: {},
    diagramaPorLegajo: {},
    diagramaPorDni: {},
  }),
  methods: {
    isEditor(modulo) {
      if (userPermission.find(record => record.ModulosAccess === modulo)) {
        return userPermission.find(record => record.ModulosAccess === modulo).Editor;
      }
      return false;
    },

    addZero(i) {
      return i < 10 ? "0" + i : i;
    },

    timestampActual() {
      const h = new Date();
      const hora = this.addZero(h.getHours());
      const minutos = ("0" + h.getMinutes()).substr(-2);
      const segundos = ("0" + h.getSeconds()).substr(-2);

      const today = new Date();
      const m = today.getMonth() + 1;
      const mes = m < 10 ? "0" + m : m;
      let dia = today.getDate();
      dia = dia < 10 ? "0" + dia : dia;

      return today.getFullYear() + "-" + mes + "-" + dia + " " + hora + ":" + minutos + ":" + segundos;
    },

    usuarioNombre() {
      const nombre = `${userData.leg_nombre || ""} ${userData.leg_apellido || ""}`.trim();
      return nombre || userData.name || "Usuario Génesis";
    },

    usuarioDni() {
      return userData.leg_numdoc || userData.dni || "-";
    },

    usuarioLegajo() {
      return userData.leg_numero || userData.legajo || "-";
    },

    claveNormalizada(value) {
      return String(value == null ? "" : value).trim();
    },

    clavesCompatibles(value) {
      const raw = this.claveNormalizada(value);
      if (!raw) return [];

      const keys = [raw];
      if (/^\d+$/.test(raw)) {
        const sinCeros = raw.replace(/^0+/, "") || "0";
        if (sinCeros !== raw) keys.push(sinCeros);
      }

      return [...new Set(keys)];
    },

    registrarMapa(mapa, clave, valor) {
      if (!clave) return;
      if (!mapa[clave]) mapa[clave] = valor;
    },

    registrarMapaCompatible(mapa, valorClave, valor) {
      this.clavesCompatibles(valorClave).forEach((clave) => {
        this.registrarMapa(mapa, clave, valor);
      });
    },

    cargarDiagramaFull() {
      if (this.diagramaCargado) {
        return $.Deferred().resolve().promise();
      }

      if (this.diagramaPromise) {
        return this.diagramaPromise;
      }

      this.diagramaCargando = true;
      console.log("Cargando memoria diagramafull:", DIAGRAMA_FULL_URL);

      this.diagramaPromise = $.ajax({
        url: DIAGRAMA_FULL_URL,
        method: "GET",
        dataType: "json",
        cache: false
      })
        .done((data) => {
          this.armarMemoriaDiagrama(data);
        })
        .fail((error) => {
          console.error("No se pudo cargar diagramafull. Los ajustes se mostrarán con los datos guardados en Firebase.", error);
          this.diagramaFull = [];
          this.diagramaPorOperacion = {};
          this.diagramaPorOperacionLegajo = {};
          this.diagramaPorLegajo = {};
          this.diagramaPorDni = {};
        })
        .always(() => {
          this.diagramaCargando = false;
          this.diagramaCargado = true;
          this.diagramaPromise = null;
        });

      return this.diagramaPromise;
    },

    armarMemoriaDiagrama(data) {
      const lista = Array.isArray(data) ? data : Object.values(data || {});
      const porOperacion = {};
      const porOperacionLegajo = {};
      const porLegajo = {};
      const porDni = {};

      lista.forEach((operacion) => {
        if (!operacion) return;

        const opInfo = {
          operacion_id: this.claveNormalizada(operacion.operacion_id),
          operacion_name: operacion.operacion_name || "-",
          zonal: operacion.zonal || "-",
          zonal_dni: operacion.zonal_dni || "-",
          zonal_legajo: operacion.zonal_legajo || "-",
          regional: operacion.regional || "-",
          regional_dni: operacion.regional_dni || "-",
          regional_legajo: operacion.regional_legajo || "-"
        };

        this.registrarMapaCompatible(porOperacion, opInfo.operacion_id, opInfo);

        (operacion.personal || []).forEach((persona) => {
          if (!persona) return;

          const personaInfo = {
            ...opInfo,
            personal_legajo: this.claveNormalizada(persona.legajo),
            personal_nombre: persona.nombre || "-",
            personal_dni: persona.dni || "-",
            personal_cat_descrip: persona.cat_descrip || "-"
          };

          this.clavesCompatibles(opInfo.operacion_id).forEach((opKey) => {
            this.clavesCompatibles(persona.legajo).forEach((legajoKey) => {
              this.registrarMapa(porOperacionLegajo, `${opKey}|${legajoKey}`, personaInfo);
            });
          });

          this.registrarMapaCompatible(porLegajo, persona.legajo, personaInfo);
          this.registrarMapaCompatible(porDni, persona.dni, personaInfo);
        });
      });

      this.diagramaFull = lista;
      this.diagramaPorOperacion = porOperacion;
      this.diagramaPorOperacionLegajo = porOperacionLegajo;
      this.diagramaPorLegajo = porLegajo;
      this.diagramaPorDni = porDni;

      console.log("Memoria diagramafull cargada", {
        operaciones: Object.keys(this.diagramaPorOperacion).length,
        personalPorOperacionLegajo: Object.keys(this.diagramaPorOperacionLegajo).length,
        personalPorLegajo: Object.keys(this.diagramaPorLegajo).length
      });
    },

    buscarInfoDiagrama(item) {
      const opKeys = this.clavesCompatibles(item.operacion_id);
      const legajoKeys = this.clavesCompatibles(item.legajo);
      const dniKeys = this.clavesCompatibles(item.dni || item.documento || item.cuil || item.personal_dni);

      for (const opKey of opKeys) {
        for (const legajoKey of legajoKeys) {
          const byOperacionLegajo = this.diagramaPorOperacionLegajo[`${opKey}|${legajoKey}`];
          if (byOperacionLegajo) return byOperacionLegajo;
        }
      }

      for (const legajoKey of legajoKeys) {
        const byLegajo = this.diagramaPorLegajo[legajoKey];
        if (byLegajo) return byLegajo;
      }

      for (const dniKey of dniKeys) {
        const byDni = this.diagramaPorDni[dniKey];
        if (byDni) return byDni;
      }

      for (const opKey of opKeys) {
        const byOperacion = this.diagramaPorOperacion[opKey];
        if (byOperacion) return byOperacion;
      }

      return null;
    },

    badgeResolucion(status) {
      if (status === "Resuelto") return "badge-success";
      if (status === "Rechazado") return "badge-danger";
      return "badge-warning";
    },

    esCasoCerrado(status) {
      return status === "Resuelto" || status === "Rechazado";
    },

    normalizarStatusResolucion(item) {
      const statusGuardado = String(item.status_resolucion || "").trim().toLowerCase();
      const estadoGuardado = String(item.estado_resolucion || "").trim().toLowerCase();

      if (statusGuardado === "rechazado" || estadoGuardado === "rechazado" || item.rechazado === true) {
        return "Rechazado";
      }

      if (statusGuardado === "resuelto" || estadoGuardado === "resuelto" || item.resuelto === true) {
        return "Resuelto";
      }

      // Compatibilidad con registros históricos que solo tenían cerrado = 1.
      if (item.cerrado === 1 || item.cerrado === true) {
        return item.rechazado === true ? "Rechazado" : "Resuelto";
      }

      return "En espera";
    },

    esAprobado(item) {
      // En este módulo hay que mostrar también los ajustes recién cargados
      // desde Regional/Consumos. Esos registros llegan como:
      // status = "En espera" y estado = "pendiente_auditoria".
      // Antes se filtraban solamente los "aprobado" y por eso Firebase
      // devolvía datos pero la tabla quedaba vacía.
      const status = String(item.status || "").trim().toLowerCase();
      const estado = String(item.estado || "").trim().toLowerCase();

      const estadosVisibles = [
        "en espera",
        "pendiente",
        "pendiente_auditoria",
        "pendiente auditoria",
        "aprobado",
        "auditado",
        "resuelto",
        "rechazado"
      ];

      return estadosVisibles.includes(status) || estadosVisibles.includes(estado);
    },

    obtenerZonal(item) {
      const zonal = item.zonal;

      if (zonal && typeof zonal === "object") {
        return zonal.nombre || zonal.name || zonal.descripcion || zonal.descrip || "-";
      }

      return zonal ||
        item.zonal_nombre ||
        item.nombre_zonal ||
        item.responsable_zonal ||
        item.zonal_responsable ||
        item.supervisor_zonal ||
        item.zonal_asignado ||
        item.zonalName ||
        item.zonal_name ||
        "-";
    },

    escucharHabilitarAjuste() {
      this.habilitarAjusteRef = firebase.database().ref("habilitarajuste");
      this.habilitarAjusteRef.on("value", (snapshot) => {
        const value = snapshot.val();

        if (value === null) {
          this.habilitarAjusteRef.set(false);
          this.habilitarAjuste = false;
          return;
        }

        this.habilitarAjuste = value === true;
      });
    },

    toggleHabilitarAjuste() {
      const nuevoValor = !this.habilitarAjuste;
      this.habilitarAjusteLoading = true;

      firebase.database().ref("habilitarajuste").set(nuevoValor)
        .then(() => {
          this.habilitarAjuste = nuevoValor;
          Swal.fire({
            icon: "success",
            title: nuevoValor ? "Ajustes habilitados" : "Ajustes deshabilitados",
            text: "El nodo habilitarajuste fue actualizado correctamente.",
            timer: 1600,
            showConfirmButton: false
          });
        })
        .catch((error) => {
          console.error("Error al actualizar habilitarajuste:", error);
          Swal.fire("Error", "No se pudo actualizar habilitarajuste en Firebase.", "error");
        })
        .finally(() => {
          this.habilitarAjusteLoading = false;
        });
    },

    normalizarAjuste(key, item) {
      const fechaCarga = item.fecha_carga || item.fecha || "-";
      const statusResolucion = this.normalizarStatusResolucion(item);
      const infoDiagrama = this.buscarInfoDiagrama(item) || {};

      return {
        fireId: key,
        fireIdCorto: key.substring(0, 8),
        fecha: item.fecha || fechaCarga,
        fecha_carga: fechaCarga,

        responsable: infoDiagrama.regional || item.regional || item.responsable || "-",
        responsable_id: item.responsable_id || "-",
        responsable_dni: infoDiagrama.regional_dni || item.regional_dni || item.responsable_dni || "-",
        responsable_legajo: infoDiagrama.regional_legajo || item.regional_legajo || item.responsable_legajo || "-",
        zonal: infoDiagrama.zonal || this.obtenerZonal(item),
        zonal_dni: infoDiagrama.zonal_dni || item.zonal_dni || "-",
        zonal_legajo: infoDiagrama.zonal_legajo || item.zonal_legajo || "-",

        operacion_id: infoDiagrama.operacion_id || item.operacion_id || "-",
        operacion_raiz: infoDiagrama.operacion_name || item.operacion_raiz || item.operacion_name || "-",

        legajo: item.legajo || infoDiagrama.personal_legajo || "-",
        nombre: item.nombre || infoDiagrama.personal_nombre || "-",
        categoria: infoDiagrama.personal_cat_descrip || item.categoria || item.cat_descrip || "-",

        id_novedad: item.id_novedad || item.bejerman_id || "-",
        bejerman_id: item.bejerman_id || item.id_novedad || "-",
        novedad: item.novedad || item.concepto || "-",
        concepto: item.concepto || item.novedad || "-",
        cantidad: item.cantidad || "-",
        detalle: item.detalle || "-",

        status: item.status || "Aprobado",
        estado: item.estado || "aprobado",

        auditor_nombre: item.auditor_nombre || "-",
        auditor_dni: item.auditor_dni || "-",
        auditor_legajo: item.auditor_legajo || "-",
        fecha_auditoria: item.fecha_auditoria || "-",
        observacion_auditoria: item.observacion_auditoria || "-",

        status_resolucion: statusResolucion,
        estado_resolucion: item.estado_resolucion || (
          statusResolucion === "Resuelto" ? "resuelto" :
          statusResolucion === "Rechazado" ? "rechazado" :
          "en_espera"
        ),
        cerrado: item.cerrado != null ? item.cerrado : (this.esCasoCerrado(statusResolucion) ? 1 : 0),
        resuelto: item.resuelto === true || statusResolucion === "Resuelto",
        rechazado: item.rechazado === true || statusResolucion === "Rechazado",
        resolutor_nombre: item.resolutor_nombre || "-",
        resolutor_dni: item.resolutor_dni || "-",
        resolutor_legajo: item.resolutor_legajo || "-",
        fecha_resolucion: item.fecha_resolucion || "-",
        observacion_resolucion: item.observacion_resolucion || "-",
        rechazador_nombre: item.rechazador_nombre || "-",
        rechazador_dni: item.rechazador_dni || "-",
        rechazador_legajo: item.rechazador_legajo || "-",
        fecha_rechazo: item.fecha_rechazo || "-",
        observacion_rechazo: item.observacion_rechazo || "-",
        gestor_cierre_nombre: item.cerrado_por_nombre || item.resolutor_nombre || item.rechazador_nombre || "-",
        gestor_cierre_dni: item.cerrado_por_dni || item.resolutor_dni || item.rechazador_dni || "-",
        gestor_cierre_legajo: item.cerrado_por_legajo || item.resolutor_legajo || item.rechazador_legajo || "-",
        fecha_cierre: item.fecha_cierre || item.fecha_resolucion || item.fecha_rechazo || "-",
        motivo_auditado: item.motivo_auditado || item["motivo auditado"] || item.motivoAuditado || item.motivo || item.motivo_ajuste || item.motivo_resolucion || "",
        motivo: item.motivo || item.motivo_auditado || item["motivo auditado"] || item.motivoAuditado || item.motivo_ajuste || item.motivo_resolucion || "",
        motivo_auditado_fecha: item.motivo_auditado_fecha || item.fecha_motivo_auditado || item.motivo_fecha || item.fecha_motivo || "-",
        motivo_auditado_usuario: item.motivo_auditado_usuario || item.motivo_auditado_usuario_nombre || item.motivo_usuario || item.motivo_usuario_nombre || "-",
        motivo_fecha: item.motivo_auditado_fecha || item.fecha_motivo_auditado || item.motivo_fecha || item.fecha_motivo || "-",
        motivo_usuario: item.motivo_auditado_usuario || item.motivo_auditado_usuario_nombre || item.motivo_usuario || item.motivo_usuario_nombre || "-",
      };
    },

    destruirDataTable() {
      if ($.fn.DataTable && $.fn.DataTable.isDataTable("#ajustes_resolucion")) {
        $("#ajustes_resolucion").DataTable().clear().destroy();
      }
    },

    calcularRangoMes(mesAnio) {
      const fechaMes = moment(mesAnio, "YYYY-MM", true);

      if (!fechaMes.isValid()) {
        return null;
      }

      return {
        desde: fechaMes.clone().startOf("month").format("YYYY-MM-DD"),
        hasta: fechaMes.clone().endOf("month").format("YYYY-MM-DD")
      };
    },

    firebaseAjustesUrl(rango) {
      const base = "https://aplicativos.firebaseio.com/ajustes_novedades.json";

      if (!rango) {
        return base + "?print=pretty";
      }

      return base +
        "?orderBy=" + encodeURIComponent(JSON.stringify("fecha_carga")) +
        "&startAt=" + encodeURIComponent(JSON.stringify(rango.desde)) +
        "&endAt=" + encodeURIComponent(JSON.stringify(rango.hasta + " 23:59:59"));
    },

    parsearFechaAjuste(value) {
      const limpio = String(value || "").trim();
      if (!limpio || limpio === "-") return null;

      const formatos = [
        "YYYY-MM-DD HH:mm:ss",
        "YYYY-MM-DD HH:mm",
        "YYYY-MM-DD",
        "DD/MM/YYYY HH:mm:ss",
        "DD/MM/YYYY HH:mm",
        "DD/MM/YYYY",
        "DD-MM-YYYY HH:mm:ss",
        "DD-MM-YYYY HH:mm",
        "DD-MM-YYYY"
      ];

      let fecha = moment(limpio, formatos, true);
      if (fecha.isValid()) return fecha;

      const match = limpio.match(/(\d{4}-\d{2}-\d{2}|\d{2}\/\d{2}\/\d{4}|\d{2}-\d{2}-\d{4})/);
      if (!match) return null;

      fecha = moment(match[1], ["YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"], true);
      return fecha.isValid() ? fecha : null;
    },

    ajusteDentroDeRango(item, rango) {
      if (!rango) return true;

      const fecha = this.parsearFechaAjuste(item.fecha_carga || item.fecha);
      if (!fecha) return false;

      const desde = moment(rango.desde, "YYYY-MM-DD", true).startOf("day");
      const hasta = moment(rango.hasta, "YYYY-MM-DD", true).endOf("day");

      return fecha.valueOf() >= desde.valueOf() && fecha.valueOf() <= hasta.valueOf();
    },

    procesarAjustesFirebase(dataFirebase, rango) {
      const data = [];

      Object.keys(dataFirebase || {}).forEach((key) => {
        const item = dataFirebase[key] || {};
        if (this.esAprobado(item) && this.ajusteDentroDeRango(item, rango)) {
          data.push(this.normalizarAjuste(key, item));
        }
      });

      data.sort((a, b) => {
        const fa = a.fecha_carga || "";
        const fb = b.fecha_carga || "";
        return fb.localeCompare(fa);
      });

      return data;
    },

    aplicarAjustes(dataFirebase, rango) {
      this.ajustes = this.procesarAjustesFirebase(dataFirebase, rango);
      console.log("Ajustes procesados para tabla:", this.ajustes.length, this.ajustes);
      this.load = false;

      this.$nextTick(() => {
        this.registrarEventosFiltro();
        this.initDataTable();
      });
    },

    getAjustes(rango = null) {
      if (!this.diagramaCargado) {
        this.load = true;
        this.buscandoAjustes = true;
        this.mensajeFiltroTipo = "alert-info";
        this.mensajeFiltro = "Cargando memoria de operaciones, zonales y regionales...";
        return this.cargarDiagramaFull().always(() => {
          this.getAjustes(rango);
        });
      }

      this.load = true;
      this.buscandoAjustes = true;
      this.ajustes = [];
      this.destruirDataTable();

      const url = this.firebaseAjustesUrl(rango);
      console.log("Consultando ajustes en Firebase:", url);
      this.mensajeFiltroTipo = "alert-info";
      this.mensajeFiltro = rango
        ? `Consultando ajustes desde ${rango.desde} hasta ${rango.hasta}...`
        : "Consultando todos los ajustes...";

      return $.ajax({
        url: url,
        method: "GET",
        dataType: "json",
        cache: false
      })
        .done((dataFirebase) => {
          this.aplicarAjustes(dataFirebase, rango);
          this.mensajeFiltroTipo = "alert-success";
          this.mensajeFiltro = rango
            ? `Consulta realizada: ${this.ajustes.length} ajuste(s) entre ${rango.desde} y ${rango.hasta}.`
            : `Consulta realizada: ${this.ajustes.length} ajuste(s).`;
        })
        .fail((error) => {
          if (rango) {
            console.warn("No se pudo consultar Firebase por rango. Se consulta el nodo completo y se filtra localmente.", error);
            this.mensajeFiltroTipo = "alert-warning";
            this.mensajeFiltro = "Firebase no aceptó la consulta por rango. Consultando nodo completo y filtrando localmente...";

            return $.ajax({
              url: this.firebaseAjustesUrl(null),
              method: "GET",
              dataType: "json",
              cache: false
            })
              .done((dataFirebase) => {
                this.aplicarAjustes(dataFirebase, rango);
                this.mensajeFiltroTipo = "alert-success";
                this.mensajeFiltro = `Consulta realizada: ${this.ajustes.length} ajuste(s) entre ${rango.desde} y ${rango.hasta}.`;
              })
              .fail((fallbackError) => {
                console.error("Error al obtener ajustes aprobados:", fallbackError);
                this.load = false;
                this.mensajeFiltroTipo = "alert-danger";
                this.mensajeFiltro = "No se pudo consultar Firebase.";
                Swal.fire(
                  "Error",
                  "Ocurrió un error al cargar los ajustes aprobados. Revise la conexión o Firebase.",
                  "error"
                );
              })
              .always(() => {
                this.buscandoAjustes = false;
              });
          }

          console.error("Error al obtener ajustes aprobados:", error);
          this.load = false;
          this.mensajeFiltroTipo = "alert-danger";
          this.mensajeFiltro = "No se pudo consultar Firebase.";
          Swal.fire(
            "Error",
            "Ocurrió un error al cargar los ajustes aprobados. Revise la conexión o Firebase.",
            "error"
          );
        })
        .always(() => {
          if (!rango || this.mensajeFiltroTipo !== "alert-warning") {
            this.buscandoAjustes = false;
          }
        });
    },

    buscarAjustesMes() {
      const mesAnio = this.mesAnioFiltro || $("#mes_anio").val();
      console.log("Click Consultar Ajustes detectado. Mes seleccionado:", mesAnio);

      if (this.buscandoAjustes) return;

      if (!mesAnio) {
        this.mensajeFiltroTipo = "alert-warning";
        this.mensajeFiltro = "Seleccione mes y año para consultar.";
        Swal.fire("Atención", "Seleccione mes y año.", "warning");
        return;
      }

      const rango = this.calcularRangoMes(mesAnio);
      if (!rango) {
        this.mensajeFiltroTipo = "alert-warning";
        this.mensajeFiltro = "El mes y año seleccionado no es válido.";
        Swal.fire("Atención", "El mes y año seleccionado no es válido.", "warning");
        return;
      }

      this.filtroDesde = rango.desde;
      this.filtroHasta = rango.hasta;
      console.log("Rango calculado para consultar ajustes:", rango);
      this.getAjustes(rango);
    },

    verTodosAjustes() {
      this.mesAnioFiltro = "";
      this.filtroDesde = "";
      this.filtroHasta = "";
      $("#mes_anio").val("");
      this.getAjustes();
    },

    registrarEventosFiltro() {
      $(document).off("click.novedadesAjustesBuscar", "#buscar");
      $(document).on("click.novedadesAjustesBuscar", "#buscar", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.buscarAjustesMes();
      });

      $(document).off("click.novedadesAjustesVerTodos", "#limpiar_filtro_mes");
      $(document).on("click.novedadesAjustesVerTodos", "#limpiar_filtro_mes", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.verTodosAjustes();
      });

      this.$nextTick(() => {
        const btnBuscar = this.$refs.btnBuscarAjustes;
        const btnVerTodos = this.$refs.btnVerTodosAjustes;

        if (btnBuscar && !btnBuscar.dataset.listenerAjustes) {
          btnBuscar.dataset.listenerAjustes = "1";
          btnBuscar.addEventListener("click", (event) => {
            event.preventDefault();
            this.buscarAjustesMes();
          });
        }

        if (btnVerTodos && !btnVerTodos.dataset.listenerAjustes) {
          btnVerTodos.dataset.listenerAjustes = "1";
          btnVerTodos.addEventListener("click", (event) => {
            event.preventDefault();
            this.verTodosAjustes();
          });
        }
      });
    },

    initDataTable() {
      this.destruirDataTable();

      const table = $("#ajustes_resolucion").DataTable({
        language: {
          decimal: ",",
          thousands: ".",
          info: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          infoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
          infoFiltered: "(filtrado de un total de _MAX_ registros)",
          loadingRecords: "Cargando...",
          lengthMenu: "Mostrar _MENU_ registros",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior"
          },
          processing: "Procesando...",
          search: "Buscar:",
          searchPlaceholder: "Término de búsqueda",
          zeroRecords: "No se encontraron resultados",
          emptyTable: "Ningún dato disponible en esta tabla",
          aria: {
            sortAscending: ": Activar para ordenar la columna de manera ascendente",
            sortDescending: ": Activar para ordenar la columna de manera descendente"
          },
        },
        scrollX: false,
        autoWidth: false,
        search: { regex: true },
        dom: "Bfrtip",
        responsive: false,
        nowrap: false,
        order: [[3, "desc"]],
        columns: [
          { width: "95px" },
          { width: "190px" },
          { width: "95px" },
          { width: "145px" },
          { width: "150px" },
          { width: "150px" },
          { width: "115px" },
          { width: "150px" },
          { width: "85px" },
          { width: "190px" },
          { width: "150px" },
          { width: "90px" },
          { width: "170px", orderable: false },
          { width: "145px" },
          { width: "190px", orderable: false },
          { width: "145px", orderable: false }
        ],
        columnDefs: [
          { targets: "_all", className: "ajuste-celda" }
        ],
        drawCallback: function() {
          if ($.fn.DataTable && $.fn.DataTable.isDataTable("#ajustes_resolucion")) {
            $("#ajustes_resolucion").DataTable().columns.adjust();
          }
        },
        buttons: [
          "copy",
          "excel",
          "csv",
          {
            text: "En espera",
            className: "btn btn-warning",
            action: function() {
              table.columns(0).search("En espera").draw();
            }
          },
          {
            text: "Resuelto",
            className: "btn btn-success",
            action: function() {
              table.columns(0).search("Resuelto").draw();
            }
          },
          {
            text: "Rechazado",
            className: "btn btn-danger",
            action: function() {
              table.columns(0).search("Rechazado").draw();
            }
          },
          {
            text: "Todos",
            className: "btn btn-secondary",
            action: () => {
              this.verTodosAjustes();
            }
          }
        ]
      });
    },

    cambiarMotivo(event, caso) {
      const nuevoMotivo = String(event.target.value || "").trim();
      const motivoAnterior = caso.motivo_auditado || caso.motivo || "";

      if (this.esCasoCerrado(caso.status_resolucion)) {
        event.target.value = motivoAnterior;
        Swal.fire("Caso cerrado", "Este ajuste ya fue cerrado y el motivo no puede modificarse.", "info");
        return;
      }

      if (!nuevoMotivo || nuevoMotivo === motivoAnterior) {
        event.target.value = motivoAnterior;
        return;
      }

      const timestamp = this.timestampActual();
      const usuario = this.usuarioNombre();
      const ref = firebase.database().ref("ajustes_novedades/" + caso.fireId);

      const updateData = {
        motivo_auditado: nuevoMotivo,
        "motivo auditado": nuevoMotivo,
        motivo_auditado_fecha: timestamp,
        fecha_motivo_auditado: timestamp,
        motivo_auditado_usuario: usuario,
        motivo_auditado_usuario_nombre: usuario,
        motivo_auditado_usuario_dni: this.usuarioDni(),
        motivo_auditado_usuario_legajo: this.usuarioLegajo()
      };

      const historialData = {
        fecha: timestamp,
        accion: "Carga de motivo auditado de ajuste",
        motivo_auditado_anterior: motivoAnterior || "-",
        motivo_auditado_nuevo: nuevoMotivo,
        nombre: usuario,
        dni: this.usuarioDni(),
        legajo: this.usuarioLegajo()
      };

      ref.update(updateData)
        .then(() => ref.child("historial").push(historialData))
        .then(() => {
          caso.motivo_auditado = nuevoMotivo;
          caso.motivo = nuevoMotivo;
          caso.motivo_auditado_fecha = timestamp;
          caso.motivo_auditado_usuario = usuario;
          caso.motivo_fecha = timestamp;
          caso.motivo_usuario = usuario;
          Swal.fire({
            icon: "success",
            title: "Motivo guardado",
            text: "El motivo del ajuste quedó guardado correctamente.",
            timer: 1400,
            showConfirmButton: false
          });
        })
        .catch((error) => {
          console.error("Error al guardar motivo auditado de ajuste:", error);
          event.target.value = motivoAnterior;
          Swal.fire(
            "Error",
            "No se pudo guardar el motivo del ajuste. Revise la conexión e intente nuevamente.",
            "error"
          );
        });
    },

    cambiarResolucion(event, caso) {
      const nuevoStatus = event.target.value;
      const statusAnterior = caso.status_resolucion;

      if (!nuevoStatus || nuevoStatus === statusAnterior) return;

      if (this.esCasoCerrado(statusAnterior)) {
        event.target.value = statusAnterior;
        Swal.fire("Caso cerrado", "Este ajuste ya fue cerrado y no puede volver a modificarse.", "info");
        return;
      }

      if (nuevoStatus === "En espera") {
        event.target.value = statusAnterior;
        return;
      }

      if (!caso.motivo_auditado && !caso.motivo) {
        event.target.value = statusAnterior;
        Swal.fire(
          "Motivo requerido",
          `Seleccione el motivo del ajuste antes de marcarlo como ${nuevoStatus.toLowerCase()}.`,
          "warning"
        );
        return;
      }

      if (nuevoStatus === "Resuelto") {
        Swal.fire({
          title: "¿Marcar ajuste como resuelto?",
          text: `Se cerrará definitivamente el ajuste de ${caso.nombre} por ${caso.novedad}.`,
          input: "textarea",
          inputPlaceholder: "Observación opcional de resolución",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#28a745",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Sí, resolver y cerrar",
          cancelButtonText: "Cancelar"
        }).then((result) => {
          if (result.isConfirmed) {
            this.resolverAjuste(caso, result.value ? result.value.trim() : "-");
          } else {
            event.target.value = statusAnterior;
          }
        });
        return;
      }

      if (nuevoStatus === "Rechazado") {
        Swal.fire({
          title: "¿Rechazar este ajuste?",
          text: `El ajuste de ${caso.nombre} por ${caso.novedad} se cerrará como rechazado.`,
          input: "textarea",
          inputLabel: "Fundamento del rechazo",
          inputPlaceholder: "Escriba por qué se rechaza el ajuste",
          inputAttributes: {
            maxlength: "1000"
          },
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#dc3545",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Sí, rechazar y cerrar",
          cancelButtonText: "Cancelar",
          inputValidator: (value) => {
            if (!String(value || "").trim()) {
              return "Debe ingresar el fundamento del rechazo.";
            }
            return undefined;
          }
        }).then((result) => {
          if (result.isConfirmed) {
            this.rechazarAjuste(caso, String(result.value || "").trim());
          } else {
            event.target.value = statusAnterior;
          }
        });
      }
    },

    resolverAjuste(caso, observacion) {
      const timestamp = this.timestampActual();
      const resolutor = this.usuarioNombre();
      const motivoAuditado = caso.motivo_auditado || caso.motivo || "-";

      Swal.fire({
        title: "Actualizando...",
        text: "Por favor espere mientras se cierra el ajuste.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const updateData = {
        // Se mantiene la aprobación de Génesis. No se pisa status ni estado.
        status: "Aprobado",
        estado: "aprobado",

        status_resolucion: "Resuelto",
        estado_resolucion: "resuelto",
        cerrado: 1,
        resuelto: true,
        rechazado: false,
        fecha_cierre: timestamp,
        cerrado_por_nombre: resolutor,
        cerrado_por_dni: this.usuarioDni(),
        cerrado_por_legajo: this.usuarioLegajo(),
        fecha_resolucion: timestamp,
        resolutor_nombre: resolutor,
        resolutor_dni: this.usuarioDni(),
        resolutor_legajo: this.usuarioLegajo(),
        observacion_resolucion: observacion || "-",
        motivo_auditado: motivoAuditado,
        "motivo auditado": motivoAuditado,
        motivo_auditado_fecha: caso.motivo_auditado_fecha || caso.motivo_fecha || timestamp,
        motivo_resolucion_auditado: motivoAuditado
      };

      const historialData = {
        fecha: timestamp,
        accion: "Resolución de ajuste",
        status_auditoria: caso.status,
        estado_auditoria: caso.estado,
        status_resolucion_anterior: caso.status_resolucion,
        status_resolucion_nuevo: "Resuelto",
        estado_resolucion: "resuelto",
        motivo_auditado: motivoAuditado,
        observacion: observacion || "-",
        nombre: resolutor,
        dni: this.usuarioDni(),
        legajo: this.usuarioLegajo()
      };

      const ref = firebase.database().ref("ajustes_novedades/" + caso.fireId);

      ref.update(updateData)
        .then(() => ref.child("historial").push(historialData))
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Caso cerrado",
            text: "El ajuste quedó resuelto correctamente.",
            timer: 1800,
            showConfirmButton: false
          });
          this.getAjustes();
        })
        .catch((error) => {
          console.error("Error al resolver ajuste:", error);
          Swal.fire(
            "Error",
            "No se pudo resolver el ajuste. Revise la conexión e intente nuevamente.",
            "error"
          );
          this.getAjustes();
        });
    },

    rechazarAjuste(caso, observacion) {
      const timestamp = this.timestampActual();
      const rechazador = this.usuarioNombre();
      const motivoAuditado = caso.motivo_auditado || caso.motivo || "-";

      Swal.fire({
        title: "Actualizando...",
        text: "Por favor espere mientras se rechaza y cierra el ajuste.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const updateData = {
        // Se conserva la aprobación previa de Génesis y se registra por separado
        // la decisión final de este sector.
        status: "Aprobado",
        estado: "aprobado",

        status_resolucion: "Rechazado",
        estado_resolucion: "rechazado",
        cerrado: 1,
        resuelto: false,
        rechazado: true,
        fecha_cierre: timestamp,
        cerrado_por_nombre: rechazador,
        cerrado_por_dni: this.usuarioDni(),
        cerrado_por_legajo: this.usuarioLegajo(),
        fecha_rechazo: timestamp,
        rechazador_nombre: rechazador,
        rechazador_dni: this.usuarioDni(),
        rechazador_legajo: this.usuarioLegajo(),
        observacion_rechazo: observacion,
        motivo_auditado: motivoAuditado,
        "motivo auditado": motivoAuditado,
        motivo_auditado_fecha: caso.motivo_auditado_fecha || caso.motivo_fecha || timestamp,
        motivo_rechazo_auditado: motivoAuditado
      };

      const historialData = {
        fecha: timestamp,
        accion: "Rechazo de ajuste",
        status_auditoria: caso.status,
        estado_auditoria: caso.estado,
        status_resolucion_anterior: caso.status_resolucion,
        status_resolucion_nuevo: "Rechazado",
        estado_resolucion: "rechazado",
        motivo_auditado: motivoAuditado,
        observacion: observacion,
        nombre: rechazador,
        dni: this.usuarioDni(),
        legajo: this.usuarioLegajo()
      };

      const ref = firebase.database().ref("ajustes_novedades/" + caso.fireId);

      ref.update(updateData)
        .then(() => ref.child("historial").push(historialData))
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Ajuste rechazado",
            text: "El ajuste quedó rechazado y cerrado correctamente.",
            timer: 1800,
            showConfirmButton: false
          });
          this.getAjustes();
        })
        .catch((error) => {
          console.error("Error al rechazar ajuste:", error);
          Swal.fire(
            "Error",
            "No se pudo rechazar el ajuste. Revise la conexión e intente nuevamente.",
            "error"
          );
          this.getAjustes();
        });
    },

    escapeHtml(value) {
      return String(value || "-")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },

    resumenDetalle(detalle) {
      const value = String(detalle || "-").trim();
      if (!value || value === "-") return "-";
      return value.length > 45 ? value.substring(0, 45) + "..." : value;
    },

    verDetalle(caso) {
      Swal.fire({
        title: "Detalle del ajuste",
        width: 850,
        html: `
          <div style="text-align:left; font-size:14px;">
            <b>ID Firebase:</b> ${this.escapeHtml(caso.fireId)}<br>
            <b>Fecha carga:</b> ${this.escapeHtml(caso.fecha_carga)}<br>
            <b>Regional:</b> ${this.escapeHtml(caso.responsable)} (${this.escapeHtml(caso.responsable_dni)})<br>
            <b>Legajo regional:</b> ${this.escapeHtml(caso.responsable_legajo)}<br>
            <b>Zonal:</b> ${this.escapeHtml(caso.zonal)} (${this.escapeHtml(caso.zonal_dni)})<br>
            <b>Legajo zonal:</b> ${this.escapeHtml(caso.zonal_legajo)}<br>
            <b>Operación:</b> ${this.escapeHtml(caso.operacion_raiz)}<br>
            <hr>
            <b>Legajo:</b> ${this.escapeHtml(caso.legajo)}<br>
            <b>Empleado:</b> ${this.escapeHtml(caso.nombre)}<br>
            <b>Categoría:</b> ${this.escapeHtml(caso.categoria)}<br>
            <b>Concepto:</b> ${this.escapeHtml(caso.novedad)}<br>
            <b>ID concepto / Bejerman:</b> ${this.escapeHtml(caso.bejerman_id)}<br>
            <b>Cantidad:</b> ${this.escapeHtml(caso.cantidad)}<br>
            <b>Detalle:</b><br>${this.escapeHtml(caso.detalle)}<br>
            <hr>
            <b>Auditoría Génesis:</b> ${this.escapeHtml(caso.status)}<br>
            <b>Auditado por:</b> ${this.escapeHtml(caso.auditor_nombre)}<br>
            <b>DNI auditor:</b> ${this.escapeHtml(caso.auditor_dni)}<br>
            <b>Fecha auditoría:</b> ${this.escapeHtml(caso.fecha_auditoria)}<br>
            <b>Observación auditoría:</b><br>${this.escapeHtml(caso.observacion_auditoria)}<br>
            <hr>
            <b>Estado de gestión:</b> ${this.escapeHtml(caso.status_resolucion)}<br>
            <b>Motivo:</b> ${this.escapeHtml(caso.motivo_auditado || caso.motivo || "-")}<br>
            <b>Fecha motivo:</b> ${this.escapeHtml(caso.motivo_auditado_fecha || caso.motivo_fecha)}<br>
            <b>Usuario motivo:</b> ${this.escapeHtml(caso.motivo_auditado_usuario || caso.motivo_usuario)}<br>
            <b>Gestionado por:</b> ${this.escapeHtml(caso.gestor_cierre_nombre)}<br>
            <b>DNI gestor:</b> ${this.escapeHtml(caso.gestor_cierre_dni)}<br>
            <b>Fecha de cierre:</b> ${this.escapeHtml(caso.fecha_cierre)}<br>
            <b>Observación de resolución:</b><br>${this.escapeHtml(caso.observacion_resolucion)}<br>
            <b>Fundamento del rechazo:</b><br>${this.escapeHtml(caso.observacion_rechazo)}
          </div>
        `,
        confirmButtonText: "Cerrar"
      });
    }
  },

  mounted() {
    this.escucharHabilitarAjuste();
    this.registrarEventosFiltro();
    this.cargarDiagramaFull().always(() => {
      this.getAjustes();
    });
  },

  beforeUnmount() {
    $(document).off("click.novedadesAjustesBuscar", "#buscar");
    $(document).off("click.novedadesAjustesVerTodos", "#limpiar_filtro_mes");
    this.destruirDataTable();
    if (this.habilitarAjusteRef) {
      this.habilitarAjusteRef.off();
    }
  }
};
</script>

<style type="text/css">
.imprimir {
  color: #212529 !important;
  background-color: #fbbc06 !important;
  border-color: #fbbc06 !important;
}

.habilitar-ajuste-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  background: #f8f9fa;
}

.habilitar-ajuste-box code {
  color: #212529;
}

#ajustes_resolucion {
  width: 100% !important;
  table-layout: fixed !important;
}

#ajustes_resolucion th,
#ajustes_resolucion td {
  box-sizing: border-box;
  vertical-align: middle !important;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
  padding: 8px 10px !important;
}

#ajustes_resolucion th span {
  display: block;
  line-height: 1.15;
}

#ajustes_resolucion .badge {
  white-space: nowrap;
}

#ajustes_resolucion .custom-select {
  min-width: 125px;
  max-width: 100%;
}

#ajustes_resolucion .btn {
  white-space: nowrap;
}

.table-responsive {
  overflow-x: auto;
}
</style>